import i18n from "../../src/localization/i18n"
const { t } = i18n.global;

const qtyElectricitySwitchgearCounters = {
    inputs: 2,
    outputs: 2
}

const electricityCounterModels = [
    {
        id: 3,
        name: t('electricity.consumer.model.legacy')
    },
    {
        id: 6,
        name: t('electricity.consumer.model.gamaG3B')
    },
    {
        id: 7,
        name: t('electricity.consumer.model.gamaG1B')
    },
    {
        id: 8,
        name: t('electricity.consumer.model.gamaM')
    }
]

const electricityInputs = [
    {
        id: 1,
        name: '1'
    },
    {
        id: 2,
        name: '2'
    }
]

export {
    qtyElectricitySwitchgearCounters,
    electricityCounterModels,
    electricityInputs
}